import { useEffect, useState } from "react"

// Ancho a partir del cual una tabla de varias columnas ya no se puede leer.
// Es el mismo corte que usa el resto de la app para "movil".
const CORTE_POR_OMISION = 768

/**
 * True mientras la pantalla sea de telefono. Escucha el cambio, asi que tambien
 * responde al girar el aparato o al cambiar el tamano de la ventana.
 */
export const useEsTelefono = (corte : number = CORTE_POR_OMISION) : boolean =>
{
	const consultaTexto = "(max-width: " + corte + "px)"

	const [esTelefono, setEsTelefono] = useState<boolean>(
		() => typeof window !== "undefined" && window.matchMedia(consultaTexto).matches
	)

	useEffect
	(
		() =>
		{
			if(typeof window === "undefined") return

			const consulta = window.matchMedia(consultaTexto)
			const avisar   = (evento : MediaQueryListEvent) => setEsTelefono(evento.matches)

			setEsTelefono(consulta.matches)

			// Safari viejo no trae addEventListener en MediaQueryList.
			if(consulta.addEventListener) consulta.addEventListener("change", avisar)
			else                          consulta.addListener(avisar)

			return () =>
			{
				if(consulta.removeEventListener) consulta.removeEventListener("change", avisar)
				else                             consulta.removeListener(avisar)
			}
		},
		[consultaTexto]
	)

	return esTelefono
}

export default useEsTelefono
